<template >
    <div>
        <template v-for="(data, index) in collapseData" >
            <div :key="index" v-if="data" style="margin-left:15px;margin-top:10px">
                <!-- <div :style="selectNode && data.link == selectNode.link && data.entitys && data.is_expand ? 'background-color:#f5f3f0' : ''"> -->
                <div :class="selectNode && data.link == selectNode.link && data.entitys && data.is_expand ? 'side-menu active' : 'side-menu'"  @click="changeExpand(data)">
                    <!-- <a-icon class="pointer" type="down" v-if="data.is_expand && data.link == selectNode.link" />
                    <a-icon class="pointer" type="right" v-else /> -->
                    <a-icon type="caret-down" v-if="data.is_expand && data.link == selectNode.link" />
                    <a-icon type="caret-right" v-else />
                    <span style="margin-left:5px"  v-if="data.entitys">{{data.name}}(<span class="info-color">{{getOrgEntitysNum(data).onlineEntitysNum}}</span>/{{getOrgEntitysNum(data).entitysNum}})</span>
                </div>

                <z-collapse-item
                        v-if="data.is_expand"
                        :collapseData="data.children"
                        @setSelectNodeLink="setSelectNodeLink"
                        @setUnExpand="setUnExpand"
                        @changeIsExpand="changeIsExpand"
                        @changeLength="changeLength"
                        :selectNode="selectNode">
                </z-collapse-item>
                <div v-if="selectNode && data.link == selectNode.link && data.entitys && data.is_expand" style="margin-left:15px">
                    <a-list itemLayout="horizontal" :dataSource="data.length > data.entitys.length ? data.entitys.slice(0,data.entitys.length) : data.entitys.slice(0,data.length) ">
                        <a-list-item  slot="renderItem" slot-scope="item" @click.native="showInfo(item)" style="cursor: pointer; padding: 15px 0;">
                            <a-row style="width:15%">
                                <i :class="item.onlineStatus ? 'icon-online icon-lg' : 'icon-offline icon-lg'">
                                    <zx-icon type="icon-shoubiao"></zx-icon>
                                </i>
                            </a-row>
                            <a-row style="width:40%;margin-top:7px">
                                {{item.entity}}
                            </a-row>
                            <!-- 是否请假 -->
                            <a-row style="width:15%">
                                <i  v-show="item.isAbsent" :class="item.isAbsent ? 'icon-online icon-lg' : 'icon-offline icon-lg'">
                                    <zx-icon type="icon-qingjia"></zx-icon>
                                </i>
                            </a-row>
                            <a-row style="width:15%">
                                <i :class="item.sn ? 'icon-online icon-lg' : 'icon-offline icon-lg'">
                                    <zx-icon type="icon-wanbiaobangding"></zx-icon>
                                </i>
                            </a-row>
                            <a-row style="width:15%">
                                <i class="icon-alarm icon-lg" v-if="item.alarmNum > 0">
                                    <zx-icon type="icon-gaojing"></zx-icon>
                                </i>
                            </a-row>
                            <!-- <a-row style="width:10%">
                                <a-button style="font-size: 16px" shape="circle" @click="showInfo(item)">
                                    <zx-icon type="icon-dingwei"></zx-icon>
                                </a-button>
                            </a-row> -->
                        </a-list-item>
                        <div style="text-align: center;margin:10px">
                            <a v-if="data.length < data.entitys.length" @click="loadMore(data)">{{$t('home.loadMore')}}</a>
                        </div>
                    </a-list>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import bus from '../../bus/bus';
    export default {
        name: 'ZCollapseItem',
        props:["collapseData","selectNode"],
        data () {
            return {

            }
        },
        methods: {
            loadMore(data){
                data.length = data.length + 5;
                this.changeLength(data.id,data.length)
            },
            getOrgOnlineEntitysNum (entitys) {
              // console.log(this.collapseData)
              if(entitys){
                  let onlines =  entitys.filter((entity) => entity.onlineStatus === true)
                  return onlines.length
              }else{
                  return 0
              }
            },
            getOrgEntitysNum (data) {
              // console.log(data)
              let total = {
                entitysNum: 0,
                onlineEntitysNum: 0
              }
              return this.computedOrgEntitysNum(data, total)
            },
            computedOrgEntitysNum (org, total) {
              total.entitysNum += org.entitys.length
              total.onlineEntitysNum += this.getOrgOnlineEntitysNum(org.entitys)
              if (org.children && org.children.length > 0) {
                for (let i = 0; i < org.children.length; i++) {
                  this.computedOrgEntitysNum(org.children[i], total)
                }
              }
              return total
            },
            changeExpand(node) {
                node.length = 5
                node.is_expand = !node.is_expand || node.link != this.selectNode.link;
                // console.log(node)
                this.changeIsExpand(node.id,node.is_expand)
                this.changeLength(node.id,node.length)
                if(node.is_expand){
                    this.setSelectNodeLink(node.link)
                }else{
                    this.setUnExpand(node)
                }
                // this.setSelectNodeLink(node.link)
            },
            changeIsExpand(orgId,isExpand){
                this.$emit("changeIsExpand",orgId,isExpand)
            },
            changeLength(orgId,length){
                this.$emit("changeLength",orgId,length)
            },
            setSelectNodeLink(nodeLink){
                this.$emit("setSelectNodeLink",nodeLink)
            },
            setUnExpand(node){
                // console.log(node)
                this.$emit("setUnExpand",node)
            },
            emitEvent (item) {
              console.log('click') 
              bus.$emit('showInfoBox', item)
            },
            // showInfo(item) {
            //   // this.$lodash.debounce(this.emitEvent, 1000 , {leading: true})
            //   bus.$emit('showInfoBox', item)
            //   // this.debounce(item)
            //   // this.throttle(this.emitEvent(item))
            // },
            showInfo: _.throttle((item) => {
              bus.$emit('showInfoBox', item);
              
              // 点击人员时，自动获取对应场景并打开室内地图
            //   if (item.scene) {
            //     bus.$emit('openIndoorMapFromSidebar', item);
            //   }
            }, 3000, {leading: true})
        },
        created(){
          // this.debounce = item => this.$lodash.debounce(this.emitEvent(item), 1000, false)
          // this.throttle = fun => this.$lodash.throttle(fun, 3000, {leading: true})
        },
    }
</script>
<style lang="less" scoped>
@import '../../theme/color.less';
.red {
  color: @error-color;
}
.info-color {
  color: @info-color;
}
.pointer {
    cursor: pointer;
}
.side-menu {
  .pointer;
}
.active {
    color: @primary-color;
    // color: #fff;
}
</style>
